import { render, staticRenderFns } from "./zombie.vue?vue&type=template&id=50580480&scoped=true&"
var script = {}
import style0 from "./zombie.vue?vue&type=style&index=0&id=50580480&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50580480",
  null
  
)

export default component.exports